<template>
  <div class="m-main">
    <Header></Header>
    <div class="m-main-bg">
      <!-- <div class="m-main-bg-img"> -->
      <template>
        <el-carousel :interval="4000" arrow="always" class="carousel">
          <el-carousel-item v-for="item in imgArray" :key="item">
            <img v-lazy="item" alt="" class="carouselImg">
          </el-carousel-item>
        </el-carousel>
      </template>
      <!-- </div> -->
    </div>
    <div class="card-contain">
      <div v-for="(item, i) in cardData" :key="i" class="card-contain__item" @click="goToFn(item.url)">
        <div class="img"><img :src="item.imgsrc" /></div>
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <!-- <div @click="goToFn('/m-index/hld')">
      <img src="../../assets/img/hld1.jpeg"/>
    </div>
    <div>
      <img src="../../assets/img/hld2.jpeg"/>
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import img1 from '../../assets/img/config_search.png'
import img2 from '../../assets/img/config_rank.png'
import img3 from '../../assets/img/config_estimate.png'
import img4 from '../../assets/img/config_portrait.png'
import Header from '../menhu/components/m-header.vue'
import Footer from '../menhu/components/m-footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      cardData: [
        {
          imgsrc: img1,
          title: '高校查询',
          desc: '“高校查询”专题主要包括各省院校、大学名单、高校信息等内容，是为了帮助广大高考生及家长能够及时了解高校信息、能够以更快捷的方式查找到各省院校的基本情况。',
          url: '/configuration/school'
        },
        {
          imgsrc: img2,
          title: '高校排名',
          desc: '“此高校排名是参考软科中国大学排名，软科中国大学排名以服务中国高等教育发展和进步为导向，采用数百项指标变量对中国大学进行全方位、体系化、监测式评价，向学生、家长和全社会提供及时、可靠、丰富的高校可比信息。',
          url: '/configuration/ranking'
        },
        {
          imgsrc: img3,
          title: '学科评估',
          desc: '学科评估是教育部学位与研究生教育发展中心（简称学位中心）按照国务院学位委员会和教育部颁布的《学位授予与人才培养学科目录》（简称学科目录）对全国具有博士或硕士学位授予权的一级学科开展整体水平评估。2002年首次开展，截至2017年完成了四轮。',
          url: '/configuration/estimate'
        },
        {
          imgsrc: img4,
          title: '专业画像',
          desc: '专业画像通过给不同的专业描绘出各自的专业相关的信息，包括该专业的男女比例，毕业生规模等，这些数据充分地从各个维度刻画出当前专业的方方面面，也使相关人员可以第一时间了解到该专业的动态或者想要关注的高校。',
          url: '/configuration/portrait'
        }
      ],
      imgArray: [
        require('../../assets/img/config_carousel_01.jpg'),
        require('../../assets/img/config_carousel_02.jpg'),
        require('../../assets/img/config_carousel_03.jpg'),
        require('../../assets/img/config_carousel_04.jpg')]
    }
  },
  methods: {
    goToFn(url) {
      this.$router.push(url)
    }
  }
}
</script>
<style lang="less">
.carousel {
  .el-carousel__container {
    height: 350px;
  }
}
</style>
<style lang="less" scoped>
.m-main {
  // display: flex;
  // padding: 50px 50px 0;
  // justify-content: space-around;
  // background: #f7f8f9;
  height: 100vh;
  overflow: auto;

  .m-main-bg {
    background: #fff;
    width: 80%;
    height: 400px;
    margin: 30px auto;
  }
  // position: relative;
  // &-img {
  //   width: 400px;
  //   margin: 0 auto;
  //   margin-bottom: 20px;
  //   position: absolute;
  //   right: 15%;
  //   > img {
  //     width: 100%;
  //     height: 100%;
  //
  // }
  .card-contain {
    display: flex;
    justify-content: center;
    padding: 20px 10% 0;
    margin-top: -20px;
    margin-bottom: 20px;
    text-align: center;
    > div {
      border: 1px solid #e7ebf0;
      border-radius: 10px;
      max-width: 320px;
      width: 20%;
      background: #ffffff;
      height: 420px;
      .img {
        width: 80%;
        height: 200px;
        border-radius: 10px 10px 0 0;
        margin: 5px auto;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10px 10px 0 0;
        }
      }
      .title {
        // text-align: center;
        padding: 20px;
        font-size: 24px;
        font-weight: bolder;
      }
      .desc {
        font-size: 12px;
        color: #6f6f79;
        padding: 0px 20px 10px;
      }
    }
    .card-contain__item {
      cursor: pointer;
    }
    .card-contain__item:hover {
      box-shadow: -2px 0px 5px 1px #e7ebf0, 0px -2px 5px 1px #e7ebf0, 2px 0px 5px 1px #e7ebf0, 0px 2px 5px 1px #e7ebf0;
    }
    .card-contain__item + .card-contain__item {
      margin-left: 20px;
    }
  }
  .card-contain + .card-contain {
    margin-left: 20px;
  }
  // >div {
  //   width: 36%;
  //   height: 300px;
  //   margin-right: 50px;
  //   border-radius: 20px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     display: block;
  //     border-radius: 20px;
  //   }
  // }
  // >div:nth-child(2) {
  //   margin-right: 0;
  // }
}
.carousel {
  height: 350px;
}
.el-carousel__item .carouselImg {
  // line-height: 400px;
  width: 100%;
  height: 350px;
  // line-height: 300px;
}
</style>